import { Product } from 'modules/cm/store/cases/products/types';
import { Product as APIProduct } from 'modules/cm/api/cases/products/types';

export const mapProductsToDomain = (products: APIProduct[]): Product[] => {
  return products.map(
    (product: APIProduct): Product => ({
      id: product.id,
      code: product.code,
      product: product.product,
      fullname: product.fullname,
      type: product.type,
      tier: product.tier,
      availableRepaymentTypes: product.availableRepaymentTypes,
    }),
  );
};
